import { VR_DEV_DOMAIN } from "@Constants/web-portal/common";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-locize-backend";
import { initReactI18next } from "react-i18next";

const locizeOptions = {
  projectId: import.meta.env.VITE_LOCIZE_PROJECT_ID,
  apiKey: import.meta.env.VITE_LOCIZE_API_KEY,
  version: import.meta.env.VITE_LOCIZE_VERSION || "production",
  // We need to allow the VR preview domain to update the translations. This is where you are directed when previewing a challenge from the super admin tool.
  allowedAddOrUpdateHosts: [VR_DEV_DOMAIN],
};

console.log("Loading i18n from the following Locize version:", locizeOptions.version);

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    debug: true,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    backend: locizeOptions,
    saveMissing: import.meta.env.PROD,
  });

if (i18n) {
  i18n.services.formatter?.add("DATE_ENG", (value, lng, options) => {
    // some date format
    return value;
  });
}

export default i18n;
